<template>
  <div  class="panel" :style="{ '--scale-factor': scaleFactor }">
    <Header/>
    <div style="position: relative">
      <img
        src="@/assets/list/banners.png"
        style="width: 100%;height: 460px"
        alt=""
      />
      <div style="position: absolute;bottom: 12px;right:150px;color: #fffffd;cursor:pointer;">
        <span @click="$router.push({ path: '/' })">首页</span> /
        <span>{{ firstMenuName }}</span> /
        <span>{{menuName}}</span>
      </div>
    </div>
    <div
      id="detail"
      v-loading.fullscreen.lock="fullscreenLoading"
      element-loading-text="处理中…… 请耐心等待"
      element-loading-spinner="el-icon-loading"
    >
      <div class="detailBox">
        <div class="left-nav" >
          <div class="titleNav">
            <div id="nav-body"  style="width: 100%;">
              <div class="bg_title">
                <p style="color: #fff;font-size:24px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap" :title="firstMenuName">{{ firstMenuName }}</p>
                <p style="color: #fff;font-size:14px;">DETAIL</p>
              </div>
              <div v-for="(item, i) in menuList" :key="i"
              >
              <div
                @click="toList(item.id,i)"
                :class="activeMenuIndex==i?'activeBorder':'hoverBorder'"
                style="text-align: left;width:100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-top: 3px;display: flex;align-items: center;justify-content: space-between"
                :title="item.label"
              >
                <p>{{ item.lable }}</p>
                <img src="@/assets/list/active.png" alt="" style="width: 13px;height: 12px;margin-right: 40px" v-if="activeMenuIndex!=i">
                <img src="@/assets/list/actived.png" alt="" style="width: 13px;height: 12px;margin-right: 40px" v-else>
              </div>
              <el-divider></el-divider>
              </div>
            </div>
          </div>
        </div>
        <div id="right-content" class="rightContent">
          <div v-show="!showIframe && !showBadRecord">
            <div id="article-header">
              <p style="text-align: center;color: #333333;font-weight: 600;font-size: 28px;">
                {{ content.title }}
              </p >
            </div>
            <div id="article-info" style="height: 55px;background: #F8F8F8;line-height: 55px;text-align: center;color: #666666">
              <span class="info-text">来源 : {{ content.source }} <el-divider direction="vertical"></el-divider></span>
              <span class="info-text">作者 : {{ content.author }} <el-divider direction="vertical"></el-divider></span>
              <span class="info-text">发布时间 : {{ content.addDate }} </span>
<!--              <span class="info-text">点击:{{ content.hits }};</span>-->
            </div>
            <div id="article-content" class="content">
              <div  class="ql-editor" id="newsContent"></div>
            </div>
            ​
            <div
              v-for="(item, index) in content.files"
              :key="index"
              style="width: 100%; text-align: center"
            >
              <!-- <iframe

                :src="
                  '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='
                "
                width="500px"
                height="280px"
              ></iframe> -->
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: center;
                  width: 100%;
                "
                v-if="
                  item.fileSuffix == '.MP4' ||
                  item.fileSuffix == '.mp4' ||
                  item.fileSuffix == 'MP4' ||
                  item.fileSuffix == 'mp4'
                "
              >
                <video width="480" height="400" controls>
                  <source
                    :src="
                      '/mainsys/cmsapi/getFilePath?fileId=' +
                      item.id +
                      '&password='
                    "
                    type="video/mp4"
                  />
                </video>
              </div>

              <iframe
                v-if="
                  item.fileSuffix == '.pdf' ||
                  item.fileSuffix == '.PDF' ||
                  item.fileSuffix == 'PDF' ||
                  item.fileSuffix == 'pdf'
                "
                :src="
                  '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='
                "
                width="90%"
                height="600px"
              ></iframe>
              <a
                href="#"
                @click="downloadFile(item)"
                style="display: block; width: 100%; margin: 12px 0 24px 0"
              >{{ item.fileName }}</a
              >
            </div>

            <!-- <div
              style="margin: 10px 0 0 40px;"
              v-if="content.files && content.files.length > 0"
            >
                       <span style="font-size:18px;font-weight:600;color:rgba(203,203,203,1);">附件下载</span>
              <div v-for="(item, index) in content.files">
                <a
                  :href="'/mainsys/cmsapi/getFilePath?fileId=' + item.id"
                  target="_blank"
                  >{{ item.fileName }}</a
                >
                <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>
              </div>
              <div
                v-for="(item, index) in content.files"
                v-if="item.fileSuffix != '.MP4' && item.fileSuffix != '.mp4'"
              >
                <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>
              </div>
            </div> -->
          </div>

          <div v-show="showBadRecord">
            <!--显示不良记录-->
            <el-table
              default-expand-all
              stripe
              :data="mainData"
              border
              style="width: 100%; margin-top: 30px"
              :header-cell-style="{ color: '#0B52A3', textAlign: 'center' }"
              :cell-style="{ color: '#000', textAlign: 'center' }"
            >
              <el-table-column prop="labItemName" width="150px" label="序号">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="userName"
                width="150px"
                label="姓名"
              ></el-table-column>
              <el-table-column
                prop="time"
                min-width="180"
                label="时间"
              ></el-table-column>
              <el-table-column
                prop="deviceName"
                min-width="100px"
                label="设备名称"
              ></el-table-column>
              <el-table-column
                prop="detail"
                min-width="150px"
                label="种类"
              ></el-table-column>
              <el-table-column
                prop="detailLevel"
                min-width="150px"
                label="严重程度"
              ></el-table-column>
              <el-table-column
                prop="score"
                min-width="150px"
                label="扣除信用积分"
              ></el-table-column>
            </el-table>
          </div>
          <div v-show="showIframe">
            <iframe
              :src="url"
              style="
                width: 1100px;
                min-height: 600px;
                margin: 0px;
                padding: 0px;
                border: 0;
                overflow-y: hidden;
              "
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部快捷链接 -->
    <div class="bottomLink">
      <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
        <div
          v-for="(item, index) in friendshipLink.res"
          :key="index"
          class="bottomLinkList"
          :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
          @click="goLink(item)"
        >
          <div style="display:flex;align-items: center;">
            <img
              :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
              style="height: 18px;width: 18px;margin-right:12px;"
            />
            <div style="line-height: 20px;height: 20px;">
              {{ item.linkName }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- 底部版权信息 -->
    <div class="copyDiv">
      <div style="width: 100%;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
        <div class="copyDivLeft">
          <img
            :src="require('../assets/bottomLogo.png')"
            alt=""
            style="width:360px;height:50px;margin-bottom:16px"
          />
          <div class="copyDivLeftCon">建设单位：国防科技大学</div>
          <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
          <div class="copyDivLeftCon">
            推荐使用: Chrome或Firefox等主流浏览器
          </div>
          <div class="copyDivLeftCon">
            Copyright © 1999- 2024 国防科技大学 版权所有
          </div>
          <div class="copyDivLeftCon">
            总计访问次数：{{websiteVisitsNum}} 次 <span style="margin-left: 50px">年度访问次数：{{yearCount}} 次</span>
          </div>
        </div>
        <div
          class="copyDivRight"
          style="text-align:center;width: 140px"
          v-if="friendshipLink.top && friendshipLink.top.length > 0"
        >
          <img
            :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
            alt=""
            style="width:140px;height:140px;margin:0 auto;text-align: center"
          />
          <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
            {{ friendshipLink.top[0].linkName }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Header from "@/views/Header.vue";
export default {
  name: "detail",
  data() {
    return {
      mainData: [],
      showBadRecord: false,
      url: "",
      showIframe: false,
      contentId: this.$route.params.contentId,
      contentIds: this.$route.params.contentIds,
      fullscreenLoading: false,
      content: {
        files: [],
      }, //内容
      firstMenuName: "",
      secondId: "",
      menuList: [],
      activeMenuIndex:0,
      menuName:"",
      websiteVisitsNum:"",
      yearCount:'',
      top:0,
      scaleFactor: 1, // 初始缩放比例
    };
  },
  components: {
    Header,
  },
  methods: {
    handleResize() {
      const windowWidth = window.innerWidth;
      const baseWidth = 1920; // 基准宽度
      console.log(windowWidth / baseWidth);
      this.scaleFactor = windowWidth / baseWidth
    },
    goLink(item) {
      if (item.linkUrl != "/") {
        if (item.linkTarget == "_blank") {
          window.open(item.linkUrl);
        } else {
          window.location.href = item.linkUrl;
        }
      }
    },
    // 获取不良积分数据
    getTableList() {
      var fd = new FormData();
      fd.append("userId", sessionStorage.getItem("userId"));
      fd.append("pageNum", 1);
      fd.append("pageSize", 999);

      this.fullscreenLoading = true;
      axios
        .post("creditSystem/selectFlow", fd, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          this.mainData = response.data.data;
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "数据请求失败，请重试。",
            type: "error",
          });
        });
    },
    getContent() {
      this.fullscreenLoading = true;
      var fd = new FormData();
      fd.append("contentId", this.contentId);
      axios
        .post("/cmsapi/contents", fd, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((response) => {
          var recData = response.data;
          document.title=recData.content.title;
          this.content = recData.content;
          document.getElementById("newsContent").innerHTML=this.content.contentString;
          this.secondId = recData.secondId;
          console.log("recData", recData)
          this.menuName = recData.menuName;
          this.firstMenuName = recData.firstMenuName;
          this.getSecondList(recData.secondId)

          if(this.$route.params.activeName){
            this.menuName=this.$route.params.activeName
          }
          // //如果只有一条，就把一级菜单放上。
          if (recData.secondMenu.length == 0) {
            this.menuList = [
              {
                lable: recData.firstMenuName,
                id: recData.firstMenuId,
              },
            ];
          } else {
            this.menuList = recData.secondMenu;
          }
          console.log('menuList', this.menuList)

          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
        });
    },
    getSecondList(id){
      axios
        .post('/cmsapi/menus/' + id, {
          //顶部友情链接
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }).then(res=>{
        this.menuName=res.data.menuName
        let matchIndex = this.menuList.findIndex(c => c.lable == this.menuName);
        if (matchIndex != -1) {
          this.activeMenuIndex = matchIndex;
        }
        // if(res.data.secondMenu.length > 0){
        //   res.data.secondMenu.forEach((item, index) => {
        //     this.menuList.push(item)
        //   });
        // }else{
        //   this.menuList.push({
        //     label: res.data.firstMenuName,
        //     id: res.data.menuId,
        //   })
        //   console.log(this.menuList,'ll')
        // }
      })
    },
    toList: function (menuId,index) {
      this.activeMenuIndex = index;
      if(this.firstMenuName == '教学资源'){
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: menuId,menuIndex:index },
        });
      }else{
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: menuId,menuIndex:index },
        });
      }

    },
    downloadFile(fileItem) {
      //下载文件
      if (fileItem.password == "1") {
        //有密码
        this.$prompt("下载该附件需要密码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then((value) => {
            window.open(
              "/mainsys/cmsapi/downloadFile?fileId=" +
              fileItem.id +
              "&password=" +
              value.value
            );
          })
          .catch(() => {
            this.$message.info("取消下载");
          });
      } else {
        // var fd = new FormData();
        // fd.append("fileId", fileItem.id);
        // fd.append("password",'');
        // axios.post("/cmsapi/getFilePath", fd, {
        //   headers: { "Content-Type": "application/x-www-form-urlencoded" }
        // });
        window.open(
          "/mainsys/cmsapi/downloadFile?fileId=" + fileItem.id + "&password="
        );
      }
    },
    getCounts(){
        axios
          .post("/cmsapi/getAccessLogNum").then((res)=>{
          if(res.data.code == '2'){
            this.websiteVisitsNum = res.data.data
            this.yearCount=res.data.yearCount
          }
        })
    },
    // handleScroll() {
    //   var scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   console.log(scrollTop,'scrollTop');
    //   if (scrollTop > 100) {
    //     this.top = 1;
    //   } else {
    //     this.top = 0;
    //   }
    // },
  },
  watch: {
    $route(to, from) {
      var that = this;
    },
  //   监听滚动条
  },
  created() {
    this.getContent();
    this.getCounts()
    if (this.$route.params.label == "仪器预约记录") {
      this.url = this.targetUrl + "lems/synOrderIframeRecord";
      this.showIframe = true;
    } else if (this.$route.params.label == "使用记录") {
      this.url = this.targetUrl + "lems/synUseIframeRecord/my";
      this.showIframe = true;
    } else if (this.$route.params.label == "实验室预约记录") {
      this.url = this.targetUrl + "open/MyIframeAppointment";
      this.showIframe = true;
    } else if (this.$route.params.label == "考勤记录") {
      this.url =
        this.targetUrl + "mainsys/scheduling/QueryTimetableList.jsp?type=tea";
      this.showIframe = true;
    } else if (this.$route.params.label == "实验室信息") {
      this.url = this.targetUrl + "LabOverview/getCenterIframePage/cms";
      this.showIframe = true;
    } else if (this.$route.params.label == "违规扣分处罚信息") {
      this.getTableList();
      this.showBadRecord = true;
    } else if (this.$route.params.label == "成绩查询") {
      var type = sessionStorage.getItem("schType");
      if (type == "s") {
        this.url =
          this.targetUrl +
          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=manager";
      } else {
        this.url =
          this.targetUrl +
          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=select";
      }
      this.showIframe = true;
    } else {
      this.showIframe = false;
    }
    // sessionStorage.setItem('schType',data.data.schType)
  },
  mounted(){
      // document.title=this.$route.params.label
    if(this.$route.params.menuName){
      this.menuName=this.$route.params.menuName
    }
    if(this.$route.params.activeIndex){
      this.activeMenuIndex=this.$route.params.activeIndex
    }

    // let isRefresh=localStorage.getItem('isRefresh')
    // if(isRefresh=='1'){
    //   location.reload()
    //   localStorage.setItem('isRefresh','0')
    // }
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化时执行一次

  },
  beforeDestroy() {
    localStorage.setItem('isRefresh','1')
  },
};
</script>
<style scoped>

.el-divider--horizontal{
  width: calc(100% - 80px);
  margin: 16px auto !important;
}
.panel{
  transform-origin: center;
  /* 确保子元素也按比例缩放 */
  width: calc(100% / var(--scale-factor));
  height: calc(100% / var(--scale-factor));
  transform: scale(var(--scale-factor));
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(var(--scale-factor));
}
.detailBox{
  width: 100%;
  margin: 0 auto;
  padding: 50px 150px;
  display: flex;
  justify-content: space-between;
  min-height: 600px;
}
.bg_title{
  width: 100%;
  height: 122px;
  background: url("~@/assets/list/bg1s.png") no-repeat;
  background-size: 100% 100%;
  padding: 25px 0 0 40px;
  margin-bottom: 16px;
}
.left-nav{
  width: 360px;
  position: relative;
  height: 600px;
  background: #f2f2f2 url("~@/assets/bg_bottom.png") no-repeat center bottom;
  background-size: contain;
  margin-right: 50px;
}
.rightContent{
  width: calc(100% - 410px);
  min-height: 300px;
  position: relative;
}
.content >>> img {
  max-width: 100%;
  margin: auto;
  height: auto;
}
.ql-editor >>> .ql-video {
  width: 700px !important;
  height: 350px !important;
}
.activeP{
  color: #002b9e;
}
.activeBorder{
  font-size:20px;
  font-weight:700;
  color:rgba(128,128,128,1);
  cursor: pointer;
  border-left: 4px solid #176DAA;
  color: #176DAA;
  padding-left: 40px;
}
.hoverBorder{
  font-size:20px;
  font-weight:400;
  color:#333333;
  cursor: pointer;
  padding-left: 40px;
}
.bottomLink {
  height: 60px;
  width: 100%;
  /* width: calc(100% - 520px); */
  background: #105C93;
  color: #fff;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
}
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider >>> .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 40px 260px;
  background: url("../assets/bottomBgs.png") no-repeat;
  background-size: 100% 100%;
}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 12px;
}
</style>
